<template>
    <v-container class="fill-height">
        <v-layout row wrap>
            <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4 xl2 offset-xl5>
                <v-card class="reset-card">
                    <v-layout class="text-center mb-5">
                        <v-flex xs12>
                            <h1 class="pt-5">Reset Password</h1>
                        </v-flex>
                    </v-layout>
                    <v-card-text>
                        <v-form>
                            <p v-if="this.successMessage == null"> Enter your new password:</p>
                            <v-text-field v-if="this.successMessage == null" v-model="email" label="Email Address" ></v-text-field>
                            <v-text-field v-if="this.successMessage == null" v-model="password" label="Password" type="password"></v-text-field>
                            <v-text-field v-if="this.successMessage == null" v-model="confirm" label="Confirm Password" type="password"></v-text-field>
                            <div v-if="this.submitError != null" class="text-center error--text mt-3 mb-5 error-message">{{submitError}}</div>
                            <div v-if="this.successMessage != null" class="text-center success--text mt-3 mb-5 success-message">{{successMessage}}</div>
                            <div v-if="this.notMatching !== false" class="text-center error--text mt-3 mb-5 success-message">Passwords must match</div>
                            <v-btn v-if="this.successMessage == null" block depressed large @click="handleSubmit" color="accent">Submit</v-btn>
                            <v-btn v-if="this.successMessage != null" block depressed large @click="handleBack" color="accent">Back</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions} from 'vuex'
    export default {
        created(){
            this.clearSubmitSuccessMessage();
        },
        data: () => ({
            email: null,
            token: null,
            show: false,
            password: null,
            confirm: null,
            notMatching: false,
        }),
        methods: {
            ...mapActions({
                submitPassword: 'account/submitPassword', //takes token, email, password
                clearSubmitSuccessMessage: 'account/clearSubmitSuccessMessage'
            }),
            handleSubmit() {
                this.token = this.$route.params.pathMatch
                this.notMatching = (this.password !== this.confirm)
                if(!this.notMatching) {
                    this.submitPassword({email: this.email, password: this.password, token: this.token, confirm: this.confirm})
                }
            },
            handleBack() {
                this.$router.push('/')
            },
        },
        computed: {
            ...mapGetters({
                submitError: 'account/resetPasswordError',
                successMessage: 'account/resetPasswordSuccess'
            })
        },
        watch: {
            confirm: function () {
                this.notMatching = (this.password !== this.confirm)
            }
        },
    }
</script>

<style scoped>
    .reset-card {
        margin-top: 100px;
        padding: 0 20px 20px 20px;
    }
    .error-message {
        height: 20px;
        font-weight: bold;
    }
    @media only screen and (max-width: 350px) {
        .reset-card {
            margin-top: 70px;
        }
    }
</style>
